import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  button: {
    fontSize: '0.8em',
    marginTop: 20,
    textTransform: 'capitalize',
  },
}));
